import Text from "aldoo-ra/Text"

export default function PoweredBy() {
  // Footer background is always dark — keep the text readable in white.
  const text = "text-white/60"
  const link = "text-white/80 hover:text-white"

  return (
    <Text
      id="pulse_powered_by"
      variant="txt1_dim"
      className={text}
      data={{
        developer_website: (
          <a
            href="https://translate.aldoo.com/"
            target="_blank"
            className={`${link} transition-colors duration-700`}
          >
            Aldoo
          </a>
        ),
        year: new Date().getFullYear(),
      }}
    />
  )
}
